import React from 'react'
import { Pane } from 'react-leaflet'
import Control from 'react-leaflet-control'
import NKIcon from '@norkart/ikoner'
import _ from 'lodash'

import { PolygonLayer, PolygonSelectionLayer } from './PolygonSelectionLayer'
import MapClickEventHandler from './MapClickEventHandler'

import './PolygonSelection.css'

const Actions = {
    ACTIVATE: 0,
    ADD_POINT: 1,
    REMOVE_POINT: 2,
    COMPLETE_SELECTION: 3,
    DELETE: 4,
    MOUSE_MOVE: 5
}

const SelectionState = {
    INACTIVE: 0,
    SELECTING: 1,
    ACTIVE: 2
}

const defaultState = {
    selection: SelectionState.INACTIVE,
    polygon: null,
    activeSelection: null,
    mousePosition: null
}

const reduce = (state = defaultState, action) => {
    
    switch (action.type) {
        case Actions.ACTIVATE:
            return {
                selection: SelectionState.SELECTING,
                polygon: [],
                activeSelection: null
            }

        case Actions.ADD_POINT:
            return {
                ...state,
                selection: SelectionState.SELECTING,
                polygon: _.concat(state.polygon, [action.point])
            }

        case Actions.REMOVE_POINT:
            return {
                ...state,
                selection: SelectionState.SELECTING,
                polygon: _.dropRight(state.polygon)
            }

        case Actions.COMPLETE_SELECTION:
            return {
                ...state,
                selection: SelectionState.ACTIVE,
                activeSelection: state.polygon,
                fraKart: true,
                mousePosition: null
            }

        case Actions.DELETE:
            return defaultState

        case Actions.MOUSE_MOVE:
            return {
                ...state,
                mousePosition: action.point
            }
        default:
            return state
    }
}

const ControlButton = ({ icon, onClick }) => (
    <button className={icon} onClick={onClick}>
        <NKIcon icon={icon} size="1" color="nk-black" />
    </button>
)

const PolygonSelectionButton = ({ onClick }) => <ControlButton icon="polygon" onClick={onClick} />

const DeleteSelectionButton = ({ onClick }) => (
    <ControlButton icon="soppelbotte" onClick={onClick} />
)

class PolygonSelection extends React.Component {

    constructor(props) {
        super(props)

        this.delete = this.delete.bind(this)
        this.activate = this.activate.bind(this)
        this.addPoint = this.addPoint.bind(this)
        this.removePoint = this.removePoint.bind(this)
        this.completeSelection = this.completeSelection.bind(this)
        this.mapMouseMoved = this.mapMouseMoved.bind(this)
        this.state = {
            ...defaultState,
            activeSelection: (props && props.activeSelection) || null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.activeSelection !== this.state.activeSelection &&
            !_.isEqual(nextProps.activeSelection, this.state.activeSelection)
        ) {
            this.delete()
        }
    }

    activate() {
        this.setState(s => reduce(s, { type: Actions.ACTIVATE }), this.triggerSelectionChanged)
    }

    delete() {
        this.setState(s => reduce(s, { type: Actions.DELETE }), this.triggerSelectionChanged)
    }

    addPoint(point) {
        this.setState(s => reduce(s, { type: Actions.ADD_POINT, point }))
    }

    removePoint() {
        this.setState(s => reduce(s, { type: Actions.REMOVE_POINT }))
    }

    completeSelection() {
        this.setState(
            s => reduce(s, { type: Actions.COMPLETE_SELECTION }),
            this.triggerSelectionChanged
        )
    }

    mapMouseMoved(point) {
        this.setState(s => reduce(s, { type: Actions.MOUSE_MOVE, point }))
    }

    triggerSelectionChanged() {        

        if(this.state.selection === 1)
            return

        if (this.props.onSelectionChanged) {        
            
            this.props.onSelectionChanged(this.state.activeSelection)
        }
    }

    isActive() {
        return this.state.selection === SelectionState.ACTIVE
    }

    isSelecting() {
        return this.state.selection === SelectionState.SELECTING
    }

    render() {
        return (
            <Pane style={{ zIndex: 640 }} name="polygon-selection">
                {this.isSelecting() && (
                    <MapClickEventHandler
                        onClick={this.addPoint}
                        onMouseMove={this.mapMouseMoved}
                    />
                )}
                <Control position="topright">
                    <div className="polygon-selection-controls">
                        <PolygonSelectionButton onClick={this.activate} />
                        {(this.state.activeSelection || this.isSelecting()) && (                            
                            <DeleteSelectionButton onClick={this.delete} />
                        )}
                    </div>
                </Control>
                {this.isSelecting() && (
                    <PolygonSelectionLayer
                        polygon={this.state.polygon}
                        firstClicked={this.completeSelection}
                        mousePosition={this.state.mousePosition}
                    />
                )}
                {this.state.activeSelection && <PolygonLayer polygon={this.state.activeSelection} active={true} />}
            </Pane>
        )
    }
}

export default PolygonSelection



// WEBPACK FOOTER //
// ./src/felles/Kart/PolygonSelection.jsx